module.exports = __webpack_public_path__ + "img/green_090.3ef6513c.png";